"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMarkAsReadOption')(function discardMarkAsReadOption(state) {
    var optionState = state.optionState;
    optionState.behavior = null;
    optionState.delay = null;
}));
//# sourceMappingURL=discardMarkAsReadOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/actions/discardMarkAsReadOption.js
// module id = 5041
// module chunks = 2